import * as React from 'react';
import clsx from 'clsx';
import { Badge, Icon, Spinner, Typography } from '../common';
import Icons from '@/const/icons';
import { ItemInboxCase, CasesListType, Subjects } from '@/interfaces/inbox';

interface ListCaseOptionsComponentProps {
	cases: ItemInboxCase[] | undefined;
	classNameCard?: string;
	subjects?: Subjects[];
	setCaseSelected?: (value: CasesListType) => void;
}

export const ListCaseOptionsComponent: React.FC<
	ListCaseOptionsComponentProps
> = ({ cases, subjects, setCaseSelected, classNameCard }) => {
	const [casesList, setCasesList] = React.useState<CasesListType[]>();

	React.useEffect(() => {
		if (cases) {
			let caseAuxList: CasesListType[] = [];
			cases.forEach((item) => {
				caseAuxList.push({
					id: item.applicationId,
					category: item.case?.category.categoryName,
					title: item.case.caseName,
				});
			});

			const extraOptions: CasesListType[] = [];
			subjects?.forEach((subject) => {
				extraOptions.push({
					id: subject.id,
					category: subject.title.startsWith('General') ? 'General' : 'Account',
					title: subject.title,
				});
			});

			const subjectOrder = ['Account Settings', 'General Question'];
			extraOptions.sort(
				(a, b) => subjectOrder.indexOf(a.title) - subjectOrder.indexOf(b.title)
			);

			caseAuxList = [...caseAuxList, ...extraOptions];
			setCasesList(caseAuxList);
		}
	}, [cases, subjects]);

	return (
		<div className="lg:w-[656px]">
			<ul>
				{casesList ? (
					casesList.map((caseCurrent, index) => (
						<li
							key={'case-inquire-' + index}
							className={clsx(
								'border border-transparent',
								'bg-grey-5 p-4 rounded-xl mb-3 text-left cursor-pointer',
								'hover:border-green-base active:border-none',
								'active:bg-green-secondary focus:bg-green-secondary',
								{
									'flex items-center gap-x-2':
										caseCurrent.category === 'General' ||
										caseCurrent.category === 'Account',
								},
								classNameCard
							)}
							onClick={() => setCaseSelected?.(caseCurrent)}
						>
							{caseCurrent.category === 'General' ||
							caseCurrent.category === 'Account' ? (
								<span className="w-4 h-4">
									<Icon
										src={Icons.pinFulledGreen}
										className="!w-4 !h-4"
										width={16}
									/>
								</span>
							) : (
								<Badge type={caseCurrent.category} size="small" />
							)}
							<Typography type="regular-16" className="mt-2">
								{caseCurrent.title}
							</Typography>
						</li>
					))
				) : (
					<div className="flex justify-center items-center w-full h-full my-10">
						<Spinner type="loadingPage" />
					</div>
				)}
			</ul>
		</div>
	);
};
